export default __webpack_public_path__ + "static/media/labirinto.7fcafc25.png";